import { useMemo } from 'react';
import { Rating as FlowRiteRating, FlowbiteSizes } from 'flowbite-react';
import { cn } from '@restworld/utils-common';
import { ratingNumberRange, getRange } from '@restworld/utils-common';
import { RATING_RANGE } from '@restworld/utility-types';

const FlowRiteRatingStar = FlowRiteRating.Star;
export interface RatingProps {
  rating: RATING_RANGE;
  size?: keyof FlowbiteStarSizes;
  className?: string;
}

export function Rating({ rating = 0, size, className, ...rest }: RatingProps) {
  const reviewRatingRange = useMemo(() => {
    try {
      return getRange(Number(rating.toFixed()));
    } catch (error) {
      return [];
    }
  }, [rating]);
  const ratingStarEl = useMemo(
    () => ratingNumberRange.map((v) => <FlowRiteRatingStar key={v} filled={reviewRatingRange.includes(v)} />),
    [reviewRatingRange]
  );
  return (
    <FlowRiteRating size={size} className={className} {...rest}>
      {ratingStarEl}
    </FlowRiteRating>
  );
}
export default Rating;
export interface FlowbiteStarSizes extends Pick<FlowbiteSizes, 'sm' | 'md' | 'lg' | 'xs'> {
  [key: string]: string;
}
